import { AddCircleOutline } from "@mui/icons-material";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useFormikContext } from "formik";
import { map } from "lodash";
import { v4 } from "uuid"
import { useCallback, useEffect, useMemo } from "react";
import { CreateFormData, FieldFather, Fields as Field } from "../../../types/forms";
import {
  FIELDS_TYPE_FORMS,
  FORM_FIELDS_PERSON,
} from "../../../utils/constants";
import { FieldForm } from "../../FieldForm";
import { useStyles } from "./styles";

export function Fields() {
  const formik = useFormikContext<CreateFormData>();
  const styles = useStyles();

  const hasCustomerLikes = useMemo(() => {
    return (
      formik.values.typeForm === "CUSTOMER_LIKES" &&
      !formik.values.fields.some((value) => value.key?.value === "documento")
    );
  }, [formik.values.fields, formik.values.typeForm]);

  useEffect(() => {
    if (hasCustomerLikes) {
      formik.setFieldValue("fields", [
        {
          inputType: FIELDS_TYPE_FORMS[0],
          active: 1,
          required: 1,
          label: "Documento",
          key: FORM_FIELDS_PERSON[1],
          disabled: true,
          guid: v4()
        },
        ...formik.values.fields,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasCustomerLikes]);

  const handleNewField = useCallback((fieldFather?: FieldFather, idFather?: number, guidFather?: string) => {
    formik.setFieldValue("fields", [
      ...formik.values.fields,
      {
        inputType: FIELDS_TYPE_FORMS[0],
        active: 1,
        required: 0,
        ...(fieldFather && {
          fieldFather: fieldFather,
          isFieldSon: true
        }),
        ...(idFather && {
          idFather: idFather
        }),
        ...(guidFather && {
          guidFather: guidFather
        }),
        guid: v4()
      },
    ]);
  }, [formik]);

  const removedRecursiveFieldForm = useCallback((fieldRemoved: Field) => {
    let fieldsSonRemoved = [];
    formik.values.fields.forEach((field) => {
      if (field.guidFather === fieldRemoved.guid) {
        fieldsSonRemoved.push(field);
      }
    });
    if (fieldsSonRemoved.length) {
      for (let i = 0; i < fieldsSonRemoved.length; i++) {
        removedRecursiveFieldForm(fieldsSonRemoved[i]);
      }
    }
    let indexFieldRemoved = -1;
    formik.values.fields.forEach((field, index) => {
      if (field.guid === fieldRemoved.guid) {
        indexFieldRemoved = index;
      }
    });
    if (indexFieldRemoved > -1) {
      let newArray = formik.values.fields;
      newArray.splice(indexFieldRemoved, 1);
      formik.setFieldValue("fields", newArray);
    }
  }, [formik])

  const removedRecursiveFieldFormDeleteOption = useCallback((fieldRemoved: Field, index: number) => {
    let fieldsSonRemoved = [];
    formik.values.fields.forEach((field) => {
      if (field.guidFather === fieldRemoved.guid && field.fieldFather.indexOptionSelectFieldFather === index) {
        fieldsSonRemoved.push(field);
      }
    });
    if (fieldsSonRemoved.length) {
      for (let i = 0; i < fieldsSonRemoved.length; i++) {
        removedRecursiveFieldForm(fieldsSonRemoved[i]);
      }
    }
  }, [formik.values.fields, removedRecursiveFieldForm])

  const onUpdatedQuestAnsw = useCallback((fieldFather: Field, id?: number) => {
    let tempFields = formik.values.fields;
    if (id !== undefined) {
      tempFields.forEach((field, index) => {
        if (field.isFieldSon &&
          (field.guidFather === fieldFather.guid) &&
          (field.fieldFather.indexOptionSelectFieldFather === id)) {
          tempFields[index].fieldFather.optionSelectFieldFather = fieldFather.optionSelect[id]
        }
      });
    } else {
      tempFields.forEach((field, index) => {
        if (field.isFieldSon && (field.guidFather === fieldFather.guid)) {
          tempFields[index].fieldFather.labelFather = fieldFather.label
        }
      });
    }
    formik.setFieldValue('fields', tempFields);
  }, [formik])

  const handleRemoveField = useCallback(
    (id: number) => {
      if (formik.values.typeForm === "CUSTOMER_LIKES") {
        removedRecursiveFieldForm(formik.values.fields[id]);
      } else {
        let tempFields = formik.values.fields;
        tempFields.splice(id, 1);
        formik.setFieldValue("fields", tempFields);
      }
      //updating parent field index in child field
      formik.values.fields.forEach((field, index) => {
        if (field.isFieldSon) {
          formik.values.fields.forEach((father, indexFather) => {
            if (father.guid === field.guidFather) {
              formik.values.fields[index].fieldFather.indexFieldFather = indexFather;
            }
          })
        }
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [formik]
  );

  const handleDuplicateField = useCallback(
    (id: number) => {
      formik.setFieldValue("fields", [
        ...formik.values.fields,
        formik.values.fields[id],
      ]);
    },
    [formik]
  );

  const handleChange = useCallback(
    (item: { [key: string]: any }, id: number) => {
      const tempFields = formik.values.fields;

      if (
        item?.inputType?.value === "select" ||
        item?.inputType?.value === "checkbox"
      ) {
        item = { ...item, optionSelect: [undefined] };
      }

      const newValueField = { ...tempFields[id], ...item };
      tempFields[id] = newValueField;
      formik.setFieldValue("fields", tempFields);
    },
    [formik]
  );

  return (
    <>
      <div className={styles.rootHeader}>
        <Typography color="primary">Campos</Typography>
        <Button
          onClick={() => { handleNewField(null) }}
          variant="outlined"
          startIcon={<AddCircleOutline />}
        >
          Adicionar campo
        </Button>
      </div>
      <div className={styles.rootContent}>
        {formik.errors.fields && !Array.isArray(formik.errors.fields) && (
          <Alert variant="filled" severity="error">
            {formik.errors.fields}
          </Alert>
        )}
        {map(formik.values.fields, (field, index) => (
          <FieldForm
            isAddClients={formik.values.typeForm === "ADD_CLIENTS"}
            isCustumer_Likes={formik.values.typeForm === "CUSTOMER_LIKES"}
            disableButtonRemove={index === 0}
            data={field}
            error={formik.errors.fields ? formik.errors.fields[index] : {}}
            key={index.toString()}
            onChange={(key, value) => handleChange({ [key]: value }, index)}
            onRemove={() => {
              handleRemoveField(index);
            }}
            onDuplicate={() => handleDuplicateField(index)}
            onFieldSon={(
              indexOptionSelectFieldFather,
              optionSelectFieldFather
            ) => handleNewField({
              labelFather: field.label,
              indexFieldFather: index,
              indexOptionSelectFieldFather: indexOptionSelectFieldFather,
              optionSelectFieldFather: optionSelectFieldFather
            }, field.id_form_campo, field.guid)}
            onDeleteOption={
              formik.values.typeForm === "CUSTOMER_LIKES"
                ? (idOption: number) => { removedRecursiveFieldFormDeleteOption(field, idOption) }
                : null
            }
            onUpdatedQuestAnsw={
              formik.values.typeForm === "CUSTOMER_LIKES"
                ? (id) => { onUpdatedQuestAnsw(field, id) }
                : null
            }
          />
        ))}
      </div>
    </>
  );
}
